import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { PathwayStateTypeLabelMap, PathwayStateTypes } from '@app/pathway-shared';
const PathwayStateType_MandatoryProps = {
    adapter: () => SimpleListAdapter([...PathwayStateTypes], item => _jsx(_Fragment, { children: PathwayStateTypeLabelMap[item.item] })),
    caret: DropDown_DefaultCaret,
    placeholder: 'Pick A Type'
};
export const Dropdown_PathwayStateType = TS_DropDown.prepare(PathwayStateType_MandatoryProps);
//# sourceMappingURL=ui-components.js.map